import cmp from './ProposalPage'

export default cmp
